@let open = isOpen();
<div class="section">
    <h2 *ngIf="field.header && !field.collapsed">{{ field.header }}</h2>
    <button *ngIf="field.header && field.collapsed" type="button" class="section-toggle" [attr.aria-expanded]="open" (click)="toggle()">
        <ion-icon [name]="open ? 'chevron-down-outline' : 'chevron-forward-outline'"></ion-icon>
        <span>{{ field.header }}</span>
    </button>
    <label *ngIf="field.label">{{ field.label }}</label>
    <p *ngIf="field.description && !field.tooltip && open" [innerHTML]="field.description"></p>
    <ion-icon name="information-circle" *ngIf="field.description && field.tooltip" (click)="showDescription($event)"></ion-icon>
    <div [class]="field.cssClass" *ngIf="open">
        <abs-universal-field *ngFor="let sectionField of field.fields" [field]="sectionField" [formValue]="formValue"></abs-universal-field>
    </div>
</div>
